const currentCurrency = document.querySelector("[data-currency]");
const dynamicPrice = document.querySelector(".dynamic-price");
const productQuantityForm = document.querySelector(".product-form__qty-input");
const cartBtn = document.querySelector("#add-to-cart");
const tierOneDiscount = cartBtn.getAttribute("data-tier-one");
const tierTwoDiscount = cartBtn.getAttribute("data-tier-two");
const tierThreeDiscount = cartBtn.getAttribute("data-tier-three");

productQuantityForm.addEventListener("click", (e) => {
  const productQuantityValue = document.querySelector(".js-qty__num").value;
  const priceValue = dynamicPrice.getAttribute("data-original-price");

  if (!e.target.matches(".js-qty__adjust--plus")) return;

  if (productQuantityValue > 0 && productQuantityValue <= 29) {
    let priceChange = priceValue * productQuantityValue;
    dynamicPrice.innerHTML = `${(priceChange / 100).toFixed(2)}`;
  } else if (productQuantityValue >= 30 && productQuantityValue <= 89) {
    let priceChange = priceValue * productQuantityValue;
    let percentage = (tierOneDiscount / 100) * priceChange;
    let result = priceChange - percentage;

    dynamicPrice.innerHTML = `${(result / 100).toFixed(2)}`;
  } else if (productQuantityValue >= 90 && productQuantityValue <= 119) {
    let priceChange = priceValue * productQuantityValue;
    let percentage = (tierTwoDiscount / 100) * priceChange;
    let result = priceChange - percentage;

    dynamicPrice.innerHTML = `${(result / 100).toFixed(2)}`;
  } else if (productQuantityValue >= 120) {
    let priceChange = priceValue * productQuantityValue;
    let percentage = (tierThreeDiscount / 100) * priceChange;
    let result = priceChange - percentage;

    dynamicPrice.innerHTML = `${(result / 100).toFixed(2)}`;
  }
});

productQuantityForm.addEventListener("click", (e) => {
  const productQuantityValue = document.querySelector(".js-qty__num").value;
  const priceValue = dynamicPrice.getAttribute("data-original-price");
  let priceChange = priceValue * productQuantityValue;

  if (!e.target.matches(".js-qty__adjust--minus")) return;

  if (productQuantityValue > 0 && productQuantityValue <= 29) {
    let priceChange = priceValue * productQuantityValue;
    dynamicPrice.innerHTML = `${(priceChange / 100).toFixed(2)}`;
  } else if (productQuantityValue >= 30 && productQuantityValue <= 89) {
    let priceChange = priceValue * productQuantityValue;
    let percentage = (tierOneDiscount / 100) * priceChange;
    let result = priceChange - percentage;

    dynamicPrice.innerHTML = `${(result / 100).toFixed(2)}`;
  } else if (productQuantityValue >= 90 && productQuantityValue <= 119) {
    let priceChange = priceValue * productQuantityValue;
    let percentage = (tierTwoDiscount / 100) * priceChange;
    let result = priceChange - percentage;

    dynamicPrice.innerHTML = `${(result / 100).toFixed(2)}`;
  } else if (productQuantityValue >= 120) {
    let priceChange = priceValue * productQuantityValue;
    let percentage = (tierThreeDiscount / 100) * priceChange;
    let result = priceChange - percentage;

    dynamicPrice.innerHTML = `${(result / 100).toFixed(2)}`;
  }

  if (priceChange < 0) {
    return;
  }
});
